/** @format */
import angular from 'angular';

export const privatePersonInfoServiceModule = 'sis-components.service.privatePersonInfoService';

(function () {
    privatePersonInfoService.$inject = ['privatePersonInfoJSDataModel'];
    angular
        .module(privatePersonInfoServiceModule, ['sis-components.model.privatePersonInfo'])
        .factory('commonPrivatePersonInfoService', privatePersonInfoService);

    function privatePersonInfoService(privatePersonInfoJSDataModel) {
        return {
            findById(personId) {
                return privatePersonInfoJSDataModel.find(personId);
            },

            findAllByIds(personIds) {
                return privatePersonInfoJSDataModel.findAll({ id: personIds });
            },
        };
    }
})();
